import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

const NOTICE_KEY = 'cookie_notice'
const YM_ID = Number(process.env.REACT_APP_YM_ID) || 110575200

let ymLoaded = false

export function loadYM() {
    if (ymLoaded || typeof window === 'undefined') return
    ymLoaded = true

    const w = window as any
    w.ym = w.ym || function (...args: any[]) { (w.ym.a = w.ym.a || []).push(args) }
    w.ym.l = Date.now()

    const src = `https://mc.yandex.ru/metrika/tag.js?id=${YM_ID}`
    for (let i = 0; i < document.scripts.length; i++) {
        if (document.scripts[i].src === src) return
    }

    const script = document.createElement('script')
    script.src = src
    script.async = true
    document.head.appendChild(script)

    w.ym(YM_ID, 'init', {
        ssr: true,
        webvisor: false,
        clickmap: false,
        accurateTrackBounce: true,
        trackLinks: true,
    })
}

function isTrackablePath(path: string): boolean {
    return !path.startsWith('/dashboard')
}

export const AnalyticsGate: React.FC = () => {
    const { pathname } = useLocation()

    useEffect(() => {
        if (!isTrackablePath(pathname)) return
        loadYM()
        window.ym?.(YM_ID, 'hit', pathname)
    }, [pathname])

    return null
}

export function isNoticeSeen(): boolean {
    try { return localStorage.getItem(NOTICE_KEY) === '1' } catch { return false }
}

export const CookieBanner: React.FC = () => {
    const { pathname } = useLocation()
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        if (!isNoticeSeen()) setVisible(true)
    }, [])

    const dismiss = () => {
        try { localStorage.setItem(NOTICE_KEY, '1') } catch {}
        setVisible(false)
    }

    if (!isTrackablePath(pathname)) return null
    if (!visible) return null

    return (
        <div style={s.overlay}>
            <div style={s.banner}>
                <p style={s.desc}>
                    Сайт использует cookie и Яндекс.Метрику для анализа посещаемости.
                    Продолжая пользоваться сайтом, вы соглашаетесь с{' '}
                    <a href="/cookie/" target="_blank" rel="noopener noreferrer" style={s.link}>
                        политикой использования cookie
                    </a>{' '}
                    и{' '}
                    <a href="/privacy/" target="_blank" rel="noopener noreferrer" style={s.link}>
                        политикой конфиденциальности
                    </a>.
                </p>
                <button onClick={dismiss} style={s.btn}>Понятно</button>
            </div>
        </div>
    )
}

declare global {
    interface Window {
        ym?: (...args: any[]) => void
    }
}

const s: Record<string, React.CSSProperties> = {
    overlay: { position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999 },
    banner: {
        background: '#1a1a1a',
        color: '#fff',
        padding: '16px 32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 24,
        flexWrap: 'wrap',
        borderTop: '1px solid #333',
    },
    desc: { flex: 1, minWidth: 280, fontSize: 13, color: '#aaa', margin: 0, lineHeight: 1.5 },
    link: { color: '#6ee7b7', textDecoration: 'underline' },
    btn: {
        padding: '9px 24px', background: '#10b981', border: 'none', borderRadius: 2,
        color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer',
        whiteSpace: 'nowrap', flexShrink: 0,
    },
}
